<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>چت ها   </template>
                </m-h5><m-tickets-2 v-bind='{...{"defaultCategory":"\u062a\u06cc\u06a9\u062a"},...{}}' :style='""' class="" ></m-tickets-2></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mTickets2 from '@moeinmdn/miw-alpha-components/src/package/Chat/Tickets/Tickets2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mTickets2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
